import { AbstractSignatureStrategy } from "./AbstractSignatureStrategy";
import { DefaultSignature } from "./DefaultSignature";
import { ImportSignature } from "./ImportSignature";
import { SessionLessSignature } from "./SessionLessSignature";
import { SupervisorSignature } from "./SupervisorSignature";

type StrategyConstructor = new (store: any) => AbstractSignatureStrategy;

const strategyMap: Record<string, StrategyConstructor> = {
    "DefaultSignature": DefaultSignature,
    "SessionLessSignature": SessionLessSignature,
    "SupervisorSignature": SupervisorSignature,
    "ImportSignature": ImportSignature
};

/**
 * Factory pour les stratégies de signature.
 */
export class SignatureStrategyFactory {
    
    /**
     * Récupération de la stratégie de récupération du mandat
     * @param type Type de stratégie
     * @returns Stratégie
     */
    public static getStrategy(type: string, store: any): AbstractSignatureStrategy {
        const StrategyClass = strategyMap[type];

        if (StrategyClass) 
            return new StrategyClass(store);
    }
}